import styled from 'styled-components'

export const StyledLink = styled.div`
  color: #5d59d7;
  text-decoration: underline;
  cursor: pointer;
`
